// 전역 스낵바 상태와 표시 함수 (Vue 3에서 제거된 $root 이벤트 버스 대체)
import { reactive } from 'vue';

export const snackbar = reactive({
  show: false,
  text: '',
  color: 'info',
  timeout: 5000
});

export function showSnackbar({ text, color = 'info', timeout = 5000 }) {
  snackbar.text = text;
  snackbar.color = color;
  snackbar.timeout = timeout;
  snackbar.show = true;
}
